export const AGES = [
    {
        data: 'FIRST_MONTH',
        view: '1 Month'
    },
    {
        data: 'SECOND_MONTH',
        view: '2 Month'
    },
    {
        data: 'THIRD_MONTH',
        view: '3 Month'
    },
    {
        data: 'FOURTH_MONTH',
        view: '4 Month'
    },
    {
        data: 'FIFTH_MONTH',
        view: '5 Month'
    },
    {
        data: 'SIXTH_MONTH',
        view: '6 Month'
    },
    {
        data: 'SEVENTH_MONTH',
        view: '7 Month'
    },
    {
        data: 'EIGHTH_MONTH',
        view: '8 Month'
    },
    {
        data: 'NINTH_MONTH',
        view: '9 Month'
    },
    {
        data: 'TENTH_MONTH',
        view: '10 Month'
    },
    {
        data: 'ELEVENTH_MONTH',
        view: '11 Month'
    },
    {
        data: 'ONE',
        view: '1y'
    },
    {
        data: 'EIGHTEEN_MONTH',
        view: '1.5y'
    },
    {
        data: 'TWO',
        view: '2y'
    },
    {
        data: 'THREE',
        view: '3y'
    },
    {
        data: 'FOUR',
        view: '4y'
    },
    {
        data: 'FIVE',
        view: '5y'
    },
    {
        data: 'SIX',
        view: '6y'
    },
    {
        data: 'SEVEN',
        view: '7y'
    },
    {
        data: 'EIGHT',
        view: '8y'
    },
    {
        data: 'NINE',
        view: '9y'
    },
    {
        data: 'TEN',
        view: '10y'
    },
    {
        data: 'ELEVEN',
        view: '11y'
    },
    {
        data: 'TWELVE',
        view: '12y'
    },
    {
        data: 'THIRTEEN',
        view: '13y'
    },
    {
        data: 'FOURTEEN',
        view: '14y'
    },
    {
        data: 'FIFTEEN',
        view: '15y'
    },
    {
        data: 'SIXTEEN',
        view: '16y'
    },
    {
        data: 'SEVENTEEN',
        view: '17y'
    },
    {
        data: 'EIGHTEEN',
        view: '18y'
    },
    {
        data: 'OVER_EIGHTEEN_YЕARS',
        view: 'Over 18y'
    }
];


// WEBPACK FOOTER //
// ./src/constants/school-ages.js